import { io, Socket } from "socket.io-client";
import notificationStore from "stores/notification/NotificationStore";
import { Notification } from "types/notification.type";

let socket: Socket | null = null;

export const initSocket = (companyId: number): Socket => {
  if (!socket) {
    socket = io(process.env.REACT_APP_API_URL || "http://localhost:5000", {
      transports: ["websocket"],
    });

    socket.on("connect", () => {
      // console.log("⚡️ Connected to socket:", socket?.id);

      // Join company room safely
      if (socket) {
        socket.emit("joinCompanyRoom", companyId);
      }
    });

    socket.on("disconnect", () => {
      // console.log("⚡️ Socket disconnected");
    });

    // Listen for new notifications
    socket.on("newNotification", (notif: Notification) => {
      // console.log("notif =>",notif);
      notificationStore.addNotification(notif);
    });
  }

  return socket;
};

export const getSocket = (): Socket => {
  if (!socket) throw new Error("Socket not initialized!");
  return socket;
};
